<template>
	<v-tab-item>
		<v-card flat>
			<v-row no-gutters>
				<v-col cols="12" sm="6">
					<h3 class="text-h6 font-weight-bold">添付ファイル</h3>
				</v-col>
				<v-col cols="12" sm="6">
					<v-row no-gutters class="flex-nowrap">
						<v-select
							v-model="type_tag_id"
							@change="fetchFiles(pagination.current)"
							:items="type_tags"
							item-text="name"
							item-value="id"
							outlined
							dense
							hide-details
							background-color="white"
							class="mr-2"
						/>
						<input style="display: none" ref="input" type="file" @change="selectFile($event)" />
						<v-btn color="secondary" class="" @click="btnClick()">
							<v-icon>mdi-paperclip-plus</v-icon>
							ファイル追加
						</v-btn>

						<FileHistoryDialog :deleted_files="deletedFiles" btn />
					</v-row>
				</v-col>
			</v-row>
			<MatterFilesTable
				v-if="matter.id"
				:attached_files="attachedFiles"
				:pagination="pagination"
				:authority_flag="fileAuthorityFlag"
				:id="matter.id"
				@drop-files="dropFile($event)"
				@get-page="fetchFiles($event)"
				@open-file-select="btnClick()"
			/>
		</v-card>
	</v-tab-item>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import MatterFilesTable from "../../shared/MatterFilesTable.vue"
import FileHistoryDialog from "../../matter/components/FileHistoryDialog.vue"

export default {
	props: {
		id: {
			type: Number,
			required: false,
			default: null,
		},
		isFetched: {
			type: Boolean,
		},
	},
	components: {
		MatterFilesTable,
		FileHistoryDialog,
	},
	data() {
		return {
			fileAuthorityFlag: false,
			matter: {
				id: null,
			},
			attachedFiles: [],
			deletedFiles: [],
			type_tags: [],
			files: [],
			type_tag_id: null,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
		}
	},
	methods: {
		fetchFiles(page) {
			authenticate.authenticateUser()
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/matters/${this.id}/attached_files`, {
					params: { tag_id: this.type_tag_id, page: page, find_by_info: true },
					headers,
				})
				.then((res) => {
					this.matter = res.data.matter
					this.type_tags = res.data.type_tags
					this.type_tags.unshift({ id: null, name: "全てのファイル" })
					this.attachedFiles = res.data.attached_files
					this.pagination = res.data.pagination
					this.fileAuthorityFlag = res.data.authority_flag
					this.deletedFiles = res.data.deleted_files
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchFiles(page)
		},
		dropFile(files) {
			const headers = authenticate.setHeader()
			files.forEach((file) => {
				const formData = new FormData()
				formData.append("file", file)
				let config = {
					headers: {
						"content-type": "multipart/form-data",
					},
				}
				axios
					.post(`/erp/v1/matters/${this.matter.id}/attached_files`, formData, {
						params: { tag_id: this.type_tag_id, config: config },
						headers,
					})
					.then((res) => {
						this.$store.dispatch("setFlash", {
							text: "ファイルを追加しました",
							type: "notice",
						})
						this.fetchFiles(this.$route.query.page ? this.$route.query.page : 1)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			})
		},
		btnClick() {
			this.$refs.input.click()
		},
		selectFile(event) {
			const headers = authenticate.setHeader()
			const files = [...event.target.files]
			files.forEach((file) => {
				const formData = new FormData()
				formData.append("file", file)
				let config = {
					headers: {
						"content-type": "multipart/form-data",
					},
				}
				axios
					.post(`/erp/v1/matters/${this.matter.id}/attached_files`, formData, {
						params: { tag_id: this.type_tag_id, config: config },
						headers,
					})
					.then((res) => {
						this.$store.dispatch("setFlash", {
							text: "ファイルを追加しました",
							type: "notice",
						})
						this.fetchFiles(this.pagination.current)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			})
		},
	},
	watch: {
		isFetched(newVal, oldVal) {
			if (oldVal == false && newVal == true) {
				this.fetchFiles(1)
			} else if (oldVal == true && newVal == false) {
				this.attachedFiles = []
				this.type_tags = []
				this.files = []
				this.type_tag_id = null
				this.pagination = {
					count: null,
					current: 1,
					limit_value: null,
					next: null,
					pages: null,
					previous: null,
				}
			}
		},
		deep: true,
	},
}
</script>